import classnames from 'classnames';
import { useField } from 'formik';
import { Flex, Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n';
import { DonIcon } from '~/components/Icon/Don';
import { Progress } from '~/components/Progress';
import { formatCurrency, formatDon } from '~/components/Util/number';
import styles from '../LevelUpCard.module.scss';
export interface LevelUpDonCardFieldProps {
  max: number;
}

export const LevelUpDonCardField = ({ max }: LevelUpDonCardFieldProps) => {
  const [, { value, error }] = useField('balance');

  const lackingAmount = max - value;

  return (
    <BaseCard className={styles.root} shadow>
      <div className={styles.inner}>
        <div className={styles.header}>
          <Heading level={5} className={styles.title}>
            <T name="citizen_membership_levelup_sec4_title" />
          </Heading>
          <p className={styles.description}>
            <T name="citizen_membership_levelup_sec4_desc1" />
          </p>
        </div>
        <div className={styles.body}>
          <DonIcon width={100} height={100} alt="DON" className={styles.image} />
        </div>
        <div className={styles.footer}>
          <Progress className={styles.progressProgress} max={max} value={value} bubble={false} />
          <Flex container justifyContent="space-between">
            <span className={styles.progressTitle}>DON</span>
            <span className={styles.progressRatio}>
              <strong>{formatDon(value)}</strong> / {formatDon(max)}
            </span>
          </Flex>
          <p className={classnames(styles.progressDescription, { active: !error })}>
            {!error ? (
              <T name="citizen_membership_levelup_sec4_desc3" />
            ) : (
              <T
                name="citizen_membership_levelup_sec4_desc2"
                options={[formatCurrency(lackingAmount)]}
              />
            )}
          </p>
        </div>
      </div>
      <div className={styles.aside}>
        <DonIcon width={100} height={100} alt="DON" className={styles.image} />
      </div>
    </BaseCard>
  );
};
